import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesOrders } from "../../constants";
import { OrderCallConfirmation } from "../../orders.types";
import { SetOrderCallConfirmationVariables } from "./setOrderCallConfirmation.types";

export const requestSetOrderCallConfirmation = async ({
  orderId,
  result,
  comment
}: SetOrderCallConfirmationVariables): Promise<OrderCallConfirmation> => {
  return await instance.post(
    buildUrl(ApiRoutesOrders.Orders, orderId, "call-confirmation"),
    { result, comment }
  );
};
